var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-flex gl-flex-wrap gl-gap-3"},[_vm._t("default"),_vm._v(" "),_c('gl-button',{staticClass:"gl-w-full @sm/panel:gl-w-auto",attrs:{"disabled":_vm.isDisabled,"to":_vm.cancelRoute,"type":"button","category":"secondary"}},[_vm._v("\n    "+_vm._s(_vm.__('Cancel'))+"\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }